import { render, staticRenderFns } from "./InventoryHistoricalCostReportTable.vue?vue&type=template&id=606b5c7a"
import script from "./InventoryHistoricalCostReportTable.vue?vue&type=script&lang=js"
export * from "./InventoryHistoricalCostReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports